module.exports = __webpack_public_path__ + "static/media/jpeg.2d4ca709.png";